"use client";

// WO-GF-001-P1B-S13 (RW3-8) — records the mountain a hub/sub page is showing, so the content pages can
// keep that context per founder ruling (b). Writes one localStorage key and renders nothing.

import { useEffect } from "react";
import { writeMountainContext } from "./mountain-context";
import { mountainCodeFromPath } from "./hub-nav";

export default function MountainMemoryLayer() {
  useEffect(() => {
    const code = mountainCodeFromPath(location.pathname);
    if (!code) return;
    // S16 · F102 — also remember the badge THIS page was served. The mountain hub headers carry live's
    // real badge markup (`<img alt="{Name} logo" src="…mountain…">`, the same shape page.tsx's
    // extractHubBadge matches), so the content-page HUD can reuse a URL we know resolves instead of
    // string-building one that 404s for every mountain but Whistler.
    const badge = document.querySelector<HTMLImageElement>(
      'header img[alt$=" logo"][src*="mountain"], header img[alt$=" Logo"][src*="mountain"]',
    );
    writeMountainContext(code, badge?.getAttribute("src") || null);
  }, []);
  return null;
}
